export const DEFAULT_STATE = {
    data: null,
    dataAll: null,
    dataDetail: null,
    payoutEdited: null,
    isLoading: false,
    publisherSelected: null,
    statusSelected: null,
};
